import { render, staticRenderFns } from "./CampaignCreated.vue?vue&type=template&id=062205d8&scoped=true&"
import script from "./CampaignCreated.vue?vue&type=script&lang=ts&"
export * from "./CampaignCreated.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignCreated.vue?vue&type=style&index=0&id=062205d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062205d8",
  null
  
)

export default component.exports